import { LOCALES } from "~/constants/i18n";
import { AzureConfigurator } from "~/services/azure-configurator/azure-configurator";

export const getBaseUrl = (pageLocale?: LOCALES): string => {
  const locale = pageLocale ? `/${pageLocale}` : "";

  return AzureConfigurator?.getConfig(pageLocale)?.frontEndBaseUrl + locale;
};
